/**
 * 留言删除
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4331
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export const postMessageDel = (messageId: string): Promise<IStatusResponse> => {
    const param = {
        message_id: messageId,
    };
    return fetchData(Api.PROFILE_MESSAGE_DEL, param);
};
